<template>
  <v-system-bar :height="$route.path === '/' ? 50 : 25" style="position: fixed; top: 0" class="hidden_on_print">
    <v-btn v-if="$route.path !== '/'" v-on:click="$router.push({path: '/'})" :icon="true" variant="text" density="compact">
      <v-icon :icon="['fas', 'home']" />
    </v-btn>
    <v-btn v-on:click="drawer = !drawer" :icon="true" variant="text" density="compact">
      <v-icon :icon="['fas', drawer ? 'xmark' : 'bars']" />
    </v-btn>
    <div v-if="!$vuetify.display.mobile">
      РАБОЧИЙ СТОЛ НАЧАЛЬНИКА УЧАСТКА
    </div>
    <v-spacer />
    <div class="mx-3" style="opacity: 0.4;" v-if="user && user.name && !$vuetify.display.mobile">
      {{ user.name.toUpperCase() }}
    </div>
    <v-fade-transition>
      <v-btn v-if="!drawer && $route.path === '/'" v-on:click="exit()" color="black" flat rounded="xl">
        В ЕИС
        <v-icon class="ml-4" :icon="['fas', 'door-open']" />
      </v-btn>
    </v-fade-transition>
  </v-system-bar>
  <v-fade-transition>
    <v-chip elevation="10" color="black" variant="flat" id="ttb" v-if="btt" style="position: fixed; bottom: 5px; right: 5px; z-index: 5000;" v-on:click="toTop()">
      <template v-slot:prepend>
        <v-icon :icon="['fas', 'arrow-up']" /> &nbsp;
      </template>
      НАВЕРХ
    </v-chip>
  </v-fade-transition>

  <v-navigation-drawer
      v-model="drawer"
      temporary
  >
    <v-card v-if="$vuetify.display.mobile" flat>
      <template v-slot:title>
        <span style="font-size: 14px !important;">
          РАБОЧИЙ СТОЛ НУ
        </span>

      </template>
      <template v-slot:subtitle v-if="user && user.name">
        <span style="font-size: 12px !important;">
           {{ user.name.toUpperCase() }}
        </span>
      </template>
    </v-card>


    <v-list density="compact" nav class="d-flex flex-column justify-space-between">
      <v-btn  v-on:click="exit()" block color="deep-orange" flat rounded="xl">
        В ЕИС
      </v-btn>
    </v-list>

    <v-sheet class="text-center">
      <p style="font-size: 10px">GUARDIAN GROUP &copy; 2023-2024</p>
      <v-sheet class="d-flex justify-center align-center">
        <BugReport />
        <PatchNotes />
      </v-sheet>
    </v-sheet>


  </v-navigation-drawer>
</template>

<script>
import { ScrollOffsetStore } from "@/store/ScrollOffsetStore";
import PatchNotes from "@/components/Global/PatchNotes.vue";
import BugReport from "@/components/Global/BugReport.vue";
import { UserStore } from "@/store/GigaUser";
import { District__Info } from "@/store/global/districts.dictionary";
import {AppsStore} from "@/store/AppsList";


export default {
  name: "SystemBar",
  components: { BugReport, PatchNotes },
  props: {
    online: Boolean
  },
  data() {
    return {
      btt: false,
      drawer: false,
      news: this.$news.news,
      rating: 5,
      menu: false,
      labels: ['1', '2', '3', '4', '5'],
    }
  },
  computed: {
    apps: {
      get() {
        return AppsStore().get()
      },
      set(value) {
        AppsStore().set(value)
      }
    },
    district_info: {
      get() {
        return District__Info().get()
      },
      set(value) {
        District__Info().set(value)
      }
    },
    user: {
      get() {
        return UserStore().get()
      },
      set(value) {
        UserStore().set(value)
      }
    },
    offset: {
      set(value) {
        ScrollOffsetStore().set(value)
      },
      get() {
        return ScrollOffsetStore().get()
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.offset = window.scrollY || document.documentElement.scrollTop;
      this.offset > 400 ? this.btt = true : this.btt = false
    });
  },
  methods: {
    exit: function () {
      window.location.replace(`${this.$config.SSL}://${this.$config.AUTH_ADDRESS}`)
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
}

</script>

<style scoped>
.btt_hide {
  display: none;
}

#ttb {
  scale: 1;
  transition: 1s;
}

#ttb:hover {
  scale: 2;
  transform: translate(-25px, -10px);
}

@media print
{
  .hidden_on_print, .hidden_on_print *
  {
    display: none !important;
  }
}
</style>
